import React, { useEffect, useState } from "react";
import { FileIndex, UserSession } from "../types";
import { Row, Form } from "react-bootstrap";
import MediaFilter from "./mediaFilter";
import UploadButton from "./uploadButton";
import ListGroup from "react-bootstrap/ListGroup";
import { Stack, Button } from "react-bootstrap";

const FileTree: React.FC<{
  fileList: FileIndex[];
  refreshFileList: () => Promise<void>;
  selectedItem: FileIndex | undefined;
  setSelectedItem: (item: FileIndex | undefined) => void;
  videoFinished: boolean;
  userSession: UserSession;
  updateUserSession: (userSession: UserSession) => void;
}> = ({
  fileList,
  refreshFileList,
  selectedItem,
  setSelectedItem,
  videoFinished,
  userSession,
  updateUserSession,
}) => {
  const [nameFilter, setNameFilter] = useState<string>(userSession.searchText);
  const [displayedItems, setDisplayedItems] = useState<FileIndex[]>([]);
  const [treePath, setTreePath] = useState<FileIndex[]>([]);

  useEffect(() => {
    if (fileList.length > 0) {
      var filteredFiles = fileList;
      const selectionPath = [];
      for (let selected of userSession.selectedFileNames) {
        for (let item of filteredFiles) {
          if (item.fileName === selected) {
            if (item.fileType === "folder") {
              selectionPath.push(item);
              filteredFiles = item.children;
            } else if (selectedItem === undefined) {
              setSelectedItem(item);
            }
          }
        }
      }
      setTreePath(selectionPath);

      if (userSession.typeFilter !== "all") {
        filteredFiles = filteredFiles.filter(
          (x) => x.fileType === userSession.typeFilter
        );
      }
      if (userSession.searchText !== "") {
        filteredFiles = filteredFiles.filter(
          (x) =>
            x.displayName.toUpperCase().indexOf(nameFilter.toUpperCase()) > -1
        );
      }
      if (treePath.length === 0) {
        const sortedFiles = filteredFiles.sort((a, b) =>
          a.displayName.toLowerCase() < b.displayName.toLowerCase() ? -1 : 1
        );
        setDisplayedItems(sortedFiles);
      } else {
        setDisplayedItems(filteredFiles);
      }
      // if (selectedItem === undefined && userSession.selectedFileIndex >= 0) {
      //   selectItem(
      //     userSession.selectedFileIndex,
      //     sortedFiles[userSession.selectedFileIndex]
      //   );
      // }
    }
  }, [fileList, nameFilter, userSession, setSelectedItem, treePath.length]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      updateUserSession({ ...userSession, searchText: nameFilter });
    }, 500);
    return () => clearTimeout(timeoutId);
  }, [nameFilter]);

  const randomIndex = () => {
    return Math.floor(Math.random() * (displayedItems.length - 0 + 1));
  };

  useEffect(() => {
    if (videoFinished && selectedItem !== undefined) {
      if (userSession.autoplay && userSession.shuffle) {
        var idx = randomIndex();
        while (userSession.playedIndices.includes(idx)) {
          idx = randomIndex();
        }
        const newItem = displayedItems[idx];
        updateUserSession({
          ...userSession,
          playedSeconds: 0,
          playedIndices: [...userSession.playedIndices, idx],
          selectedFileNames: [
            ...treePath.map((i) => i.fileName),
            newItem.fileName,
          ],
        });
      } else if (userSession.autoplay) {
        const currIdx = displayedItems.indexOf(selectedItem);
        selectItem(displayedItems[currIdx + 1]);
      }
    }
  }, [videoFinished]);

  const selectItem = (item: FileIndex | undefined) => {
    // If user clicks "Library" link
    if (item === undefined) {
      setTreePath([]);
      updateUserSession({
        ...userSession,
        playedIndices: [],
        selectedFileNames: [],
      });
      return;
    }
    if (item.fileType === "folder") {
      setTreePath([...treePath, item]);
      setSelectedItem(undefined);
      setDisplayedItems(item.children);
    } else {
      setSelectedItem(item);
    }
    updateUserSession({
      ...userSession,
      playedSeconds: 0,
      playedIndices: [],
      selectedFileNames: [...treePath.map((i) => i.fileName), item.fileName],
    });
  };

  return (
    <div className="h-100 d-inline-flex flex-column">
      <Row>
        <Stack direction="horizontal" gap={1} className="py-1">
          <Form.Control
            placeholder="Search"
            className="mx-1"
            value={nameFilter}
            onChange={(e) => {
              setNameFilter(e.target.value);
              // updateUserSession({
              //   ...userSession,
              //   searchText: e.target.value,
              // });
            }}
          />
          <MediaFilter
            userSession={userSession}
            updateUserSession={updateUserSession}
          />
          <UploadButton refreshFileList={refreshFileList} />
        </Stack>
      </Row>
      <Stack direction="horizontal">
        <Button variant="link" onClick={() => selectItem(undefined)}>
          Library
        </Button>
        {treePath.map((item) => (
          <div key={item.fileName}>
            -&gt;
            <Button variant="link">{item.displayName}</Button>
          </div>
        ))}
      </Stack>
      <hr className="m-1" />
      <div className="flex-fill overflow-hidden">
        {displayedItems.length === 0 ? (
          <div>No files matching filters</div>
        ) : (
          <ListGroup variant="flush" className="h-100 overflow-auto">
            {displayedItems.map((item) => (
              <ListGroup.Item
                key={item.fileName}
                active={item.fileName === selectedItem?.fileName}
                onClick={() => selectItem(item)}
              >
                {item.displayName}
              </ListGroup.Item>
            ))}
          </ListGroup>
        )}
      </div>
    </div>
  );
};
export default FileTree;
